export const HIDE_LOADER = 'HIDE_LOADER';
export const SAVE_WORKLOAD = 'SAVE_WORKLOAD';
export const SET_DICTIONARY = 'SET_DICTIONARY';
export const SHOW_LOADER = 'SHOW_LOADER';
